import ApplyPage from "./ApplyPage";

const QUESTIONS = [
    {
        id: "audience",
        label: "Для кого разрабатываете софт — для внутренних нужд компании или для внешних заказчиков?",
        placeholder: "Несколько строк — этого достаточно.",
    },
    {
        id: "methodology",
        label: "Как бы вы описали методологию по которой работает команда?",
        placeholder: "Scrum, Kanban, своя смесь, ad hoc — опишите как чувствуете.",
    },
    {
        id: "task",
        label: "В какой задаче вам нужна моя поддержка?",
        placeholder: "Что сейчас болит, в чём хочется опереться на внешний взгляд.",
    },
    {
        id: "extra",
        label: "Что-то ещё хотите добавить?",
        placeholder: "Контекст, ограничения, особенности — любое полезное.",
    },
];

export default function ApplySupportPage() {
    return (
        <ApplyPage
            testid="apply"
            eyebrow="Формат 01 · Экспертная поддержка"
            title={
                <>
                    Несколько вопросов{" "}
                    <span className="font-semibold">перед встречей</span>
                </>
            }
            intro="Пожалуйста, опишите коротко, как вы работаете и в чём ищете поддержки. Ваши ответы помогут мне подготовиться к нашей встрече."
            packageName="Экспертная поддержка"
            questions={QUESTIONS}
            emailLabel="Ваш email чтобы я могла связаться с вами *"
        />
    );
}
